import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

const AgeGate = () => {
  const { language } = useLanguage();
  const [verified, setVerified] = useState(() => localStorage.getItem('age-verified') === 'true');

  if (verified) return null;

  const handleYes = () => {
    localStorage.setItem('age-verified', 'true');
    setVerified(true);
  };

  const handleNo = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur px-4" data-testid="age-gate">
      <div className="max-w-md w-full bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center">
        <h2 className="text-2xl font-bold text-white mb-2">
          Shisha<span className="text-zinc-500">Vibes</span>
        </h2>
        <p className="text-lg text-white font-semibold mb-2">
          {language === 'hu' ? 'Elmúltál 18 éves?' : 'Are you over 18?'}
        </p>
        <p className="text-sm text-zinc-400 mb-6">
          {language === 'hu'
            ? 'Ez az oldal dohányzáshoz kapcsolódó termékeket kínál. A belépéshez legalább 18 évesnek kell lenned.'
            : 'This site offers smoking-related products. You must be at least 18 to enter.'}
        </p>
        <div className="flex gap-3 justify-center">
          <Button className="flex-1 bg-white text-black hover:bg-zinc-200 font-semibold" onClick={handleYes} data-testid="age-gate-yes">
            {language === 'hu' ? 'Igen' : 'Yes'}
          </Button>
          <Button variant="outline" className="flex-1 border-zinc-700 text-white hover:bg-zinc-800" onClick={handleNo} data-testid="age-gate-no">
            {language === 'hu' ? 'Nem' : 'No'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
